import React from 'react';
import styles from './Haunt.module.scss'
import haunt from './../../../../Assets/Parents/haunt.png'
const Haunt = () => {
  return (
    <section className={styles.haunt}>
      <div className={styles.container}>
        <img src={haunt} alt='' />
        <div className={styles.textContainer}>
          <h3>Online writing club for kids (ages 9-12):</h3>
          <p>Unleash your child’s imagination beyond the classroom with weekly interactive online writing activities.</p>
          <a href="https://escribli.com/haunt" target="_blank" rel="noopener noreferrer">Find out more</a>
        </div>
      </div>
    </section>
  );
}

export default Haunt;